import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    wordFilterToggle: false,
    filterLoading: false,
    searchData: { searchText: "", type: null },
    hashtags: [],
    mentions: [],
    keywords: '',
}

const risingStarSlice = createSlice({
    name: "risingStar",
    initialState,
    reducers: {

        setRisingStarStates(state, action) {
            const { payload: { key, value } } = action
            state[key] = value;
            return state
        },
        setSearchData(state, action) {
            state.searchData = action?.payload
        },

        clearRisingStar(state, action) {
            return initialState;
        },
    }
})

export const risingStarActions = risingStarSlice.actions;

export default risingStarSlice;